var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuildkite = function SvgBuildkite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 480 320"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#buildkite_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14CC80",
    d: "M320 160v160l160-80V80z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30F2A2",
    d: "M320 0v160l160-80z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14CC80",
    d: "M160 80v160l160-80V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30F2A2",
    d: "M0 0v160l160 80V80z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "buildkite_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h480v320H0z"
  })))));
};
export default SvgBuildkite;